import { Typography } from "@mui/material";
import { FC } from "react";

interface InvoiceNumberProps {
    invoiceMonthAndYear?: string;
    invoiceNumber: number | 'auto';
}

const InvoiceNumber: FC<InvoiceNumberProps> = ({
    invoiceMonthAndYear,
    invoiceNumber
}) => {

    return (
        <Typography
            variant="h6"
            gutterBottom
            sx={{
                marginBottom: 1,
                marginTop: 2,
                fontWeight: 'bold',
                textAlign: "center",
                p: 1
            }}
        >
            Faktura pro forma {invoiceNumber}/{invoiceMonthAndYear}
        </Typography>
    )
}

export default InvoiceNumber;